"use client";

import { useState, useEffect } from "react";
import { infoCenterApi } from "../query/info-center";

export interface InfoCenterItem {
  id: number;
  infoType: string;
  infoMaterial: string;
  infoEnum?: any;
}

interface InfoCenterData {
  [key: string]: InfoCenterItem[];
}

export const useInfoCenter = () => {
  const [data, setData] = useState<InfoCenterData>({});
  const [imageUrls, setImageUrls] = useState<Record<number, string>>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAllInfoTypes = async () => {
      try {
        setLoading(true);
        const infoTypes = ["vacancy", "events", "news", "others"];
        const allData: InfoCenterData = {};
        const urls: Record<number, string> = {};

        for (const type of infoTypes) {
          const items = await infoCenterApi.getAllInfoCenter(type);
          if (items.length > 0) {
            allData[type] = items;

            // Fetch images for each item
            for (const item of items) {
              try {
                const blob = await infoCenterApi.getInfoCenterFilePics(item.id);
                urls[item.id] = URL.createObjectURL(blob);
              } catch (err) {
                console.error(`Error loading image for item ${item.id}:`, err);
              }
            }
          }
        }

        setData(allData);
        setImageUrls(urls);
        setError(null);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "Failed to load info center data"
        );
        console.error("Error fetching info center data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllInfoTypes();

    return () => {
      Object.values(imageUrls).forEach((url) => URL.revokeObjectURL(url));
    };
  }, []);

  return {
    data,
    imageUrls,
    loading,
    error,
  };
};
